import { Scenarios } from '@jfs/network'

const validateOtp = {
  default: [
    {
      url: /user\/authenticate/,
      method: 'POST',
      body: /GENERATE/,
      response: {
        status: 'SUCCESS',
        data: {
          message: 'VALIDATED',
        },
      },
      delay: 500,
    },
    {
      url: /user\/authenticate/,
      method: 'POST',
      body: /verify/,
      response: {
        status: 'SUCCESS',
        data: {
          message: 'GENERATED',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /user\/authenticate/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { validateOtp }
